import React, { useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import AddButton from "components/buttons/addbutton";
import ListHeadingComponent from "components/headingComponent/listHeading";
import {
  and, 
  collection,
  deleteDoc,
  doc, 
  getCountFromServer,
  getDocs,
  or,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import RoutingPaths from "helper/routingPath";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import Swal from "sweetalert2";
import Moment from "react-moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "primereact/button";

const BatchesList = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [batchesData, setBatchesData] = useState([]); // we fetch the data from the backend and shown in the form of list
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  // MARK: use Effect function
  useEffect(() => {
    fetchBatchesApi();
  }, []);

  // use layout effect function
  useLayoutEffect(() => {
    document.title = CommonHeadings.batchLayoutHeading;
  }, []);

  // MARK: Action
  const tapOnEdit = (batchData) => () => {
    navigate(RoutingPaths.editBatches, { state: batchData });
  };

  // view data function
  const tapOnView = (batchData) => () => {
    navigate(RoutingPaths.viewBatches, { state: batchData });
  };


  //Delete data function
  const tapOnDeleteConfirm = (batch) => () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete this batch.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        deleteBatchesApi(batch);
      }
    });
  };

  // MARK:API

  async function fetchBatchesApi() {

    let q = query(
      collection(dbFirestore, TableName.batches),
      orderBy("created_at", "desc")
    );
    const querySnapshot = await getDocs(q);
    setStudentCountList(querySnapshot);
    setLoading(false);
  }

  function setStudentCountList(querySnapshot) {
    const batchArray = [];

    if (querySnapshot.docs.length > 0) {
      querySnapshot.docs.forEach(async element => {
        let studentQuery = query(
          collection(dbFirestore, TableName.students), where("batch_firebase_id", "==", element.id),
          where("status", "==", "active"));

        const snapshot = await getCountFromServer(studentQuery);

        const finalModel = {
          count: snapshot.data() !== null ? snapshot.data().count : null,
          ...element.data(),
          firebase_id: element.id,
        }
        batchArray.push(finalModel);

        if (querySnapshot.docs.length === batchArray.length) {
          setBatchesData(batchArray);
        }
      });
    } else {
      setBatchesData(batchArray);
    }
  }


  // delete API
  const deleteBatchesApi = async (batch) => {
    await deleteDoc(doc(dbFirestore, TableName.batches, batch.firebase_id));
    setBatchesData((prevState) => prevState.filter((el) => el.id !== batch.firebase_id));
    toast.success(ToastMessages.batchDeleted);
  };

  // serach api
  const searchBatchesApi = async (e) => {
    const searchText = e.target.value.toLowerCase();

    setGlobalFilterValue(searchText);

    if (searchText) {
      let q = query(
        collection(dbFirestore, TableName.batches),
        or(
          and(
            where("batch_name", ">=", searchText),
            where("batch_name", "<=", searchText + "\uf8ff")
          ),
          and(
            where(
              "batch_name",
              ">=",
              searchText.charAt(0).toUpperCase() + searchText.slice(1)
            ),
            where(
              "batch_name",
              "<=",
              searchText.charAt(0).toUpperCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          ),
          and(
            where(
              "batch_name",
              ">=",
              searchText.charAt(0).toLowerCase() + searchText.slice(1)
            ),
            where(
              "batch_name",
              "<=",
              searchText.charAt(0).toLowerCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          )
        )
      );
      const querySnapshot = await getDocs(q);

      setStudentCountList(querySnapshot)

      // set data from docs
    } else {
      fetchBatchesApi();
    }
  };

  //MARK: Search UI
  const searchBar = () => {
    return (
      <>
        <div className="search__main_div">
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText
              type="search"
              value={globalFilterValue}
              onChange={searchBatchesApi}
              placeholder="Search by batch name"
            />
          </IconField>
        </div>
      </>
    );
  };

  const header = searchBar();

  if (isLoading) {
    return <div className="loading-div"> Loading ... </div>;
  }

  // MARK: UI data
  const batchesListColumns = [
    {
      field: "batch_name",
      header: "Batch Name",
      className: "table__column__capital",
    },
    { field: "description", header: "Description" },
    { field: "count", header: "Student Count"},
    {
      field: "created_at",
      header: "Created At",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYHHMMSS}>{data.created_at}</Moment>
      ),
    },
    {
      field: "actions",
      header: "Actions",
      CardBody: (data) => (
        <>
          <div className="d-flex mt-3 text-start">
            <Button
              type="button"
              className="lists__edit_button"
              onClick={tapOnEdit(data)}
              tooltip="edit"
              tooltipOptions={{ position: "bottom" }}
            >
              <span className="pi pi-pencil"></span>
            </Button>

            <Button
              type="button"
              className="lists__edit_button"
              onClick={tapOnView(data)}
              tooltip="view"
              tooltipOptions={{ position: "bottom" }}
            >
              <span className="pi pi-eye"></span>
            </Button>

            <Button
              severity="secondary"
              type="button"
              onClick={tapOnDeleteConfirm(data)}
              className="lists__delete_button"
              tooltip="delete"
              tooltipOptions={{ position: "bottom" }}
            >
              <span className="pi pi-trash"></span>{" "}
            </Button>
            <ToastContainer />
          </div>
          <ToastContainer />
        </>
      ),
    },
  ];

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <div className="modules__lists_main-content">
            <ListHeadingComponent
              classname="flex-grow-1"
              headingName={CommonHeadings.batchListHeading}
            />
            <AddButton navigation={RoutingPaths.addBatches} />
          </div>

          <DataTable header={header} sortField="batch_name" sortOrder={-1}
            className="mt-5 mb-3"
            value={batchesData}
            emptyMessage="No data found."
          >
            {batchesListColumns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                bodyClassName={col.className}
                body={col.CardBody}
              />
            ))}
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default BatchesList;


